import { render } from "./AccountBillingTab.vue?vue&type=template&id=68827553"
import script from "./AccountBillingTab.vue?vue&type=script&lang=js"
export * from "./AccountBillingTab.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__